import {
  CallCenterAgentQuery,
  CIReportDownloadPayload,
  CIReportFilterOptionsPayload,
  FilteredAgentQuery,
} from "./ci-report.interface";

const PREFIX = "CI REPORT";

export class GET_CI_REPORT_SEARCH {
  public static readonly type = `[${PREFIX}] GET CI REPORT SEARCH`;
  constructor(public readonly payload: CIReportDownloadPayload) {}
}

export class DOWNLOAD_CI_REPORT_FROM_URL {
  public static readonly type = `[${PREFIX}] DOWNLOAD CI REPORT FROM URL`;
  constructor(public readonly payload: CIReportDownloadPayload) {}
}

export class GET_CI_REPORT_BRANCH_LIST {
  public static readonly type = `[${PREFIX}] GET CI REPORT BRANCH LIST`;
  constructor(public readonly payload: string) {}
}

export class GET_CI_REPORT_AGENT_LIST {
  public static readonly type = `[${PREFIX}] GET CI REPORT AGENT LIST`;
  constructor(public readonly payload: string) {}
}

export class GET_FILTERED_CI_REPORT_AGENT_LIST {
  public static readonly type = `[${PREFIX}] GET FILTERED CI REPORT AGENT LIST`;
  constructor(public readonly payload: FilteredAgentQuery) {}
}

export class GET_CI_REPORT_FILTER_OPTIONS {
  public static readonly type = `[${PREFIX}] GET CI REPORT FILTER OPTIONS`;
  constructor(public readonly payload: CIReportFilterOptionsPayload) {}
}

export class GET_CI_REPORT_CC_AGENT_LIST {
  public static readonly type = `[${PREFIX}] GET CI REPORT CC AGENT LIST`;
  constructor(public readonly payload: CallCenterAgentQuery) {}
}
